import BApp from "../../Modules/BApp";
import BForm from "../../Modules/BForm";
import BDiaryDayForm from "./BDiaryDayForm";

export default class BDiaryDayMealForm extends BDiaryDayForm
{
	getForm()
	{
		return new BForm(this.el);
	}

	getDiaryDayMealId()
	{
		return parseInt(this.el.dataset.id);
	}

	getEntriesElement()
	{
		return this.el.querySelector(`.profile-diary-day-meal-components`);
	}

	getEntries()
	{
		return this.getEntriesElement().querySelectorAll(`.profile-entry`);
	}

	addEntryHtml(template)
	{
		this.getEntriesElement().innerHTML += template;
	}

	updateValues(values)
	{
		if (values?.servings?.formatted || false) {
			try {
				this.el.querySelector(`[name="servings"]`).value = values.servings.formatted;
			} catch (error) {
				// Nevermind.
			}
		}

		if (values?.weight?.formatted || false) {
			try {
				this.el.querySelector(`[name="weight"]`).value = values.weight.formatted;
			} catch (error) {
				// Nevermind.
			}
		}

		for (let id in values?.ingredients || []) {
			let ingredient = values.ingredients[id];
			this.el.querySelector(`.profile-diary-day-meal-ingredient[data-id="${id}"] .profile-diary-day-meal-ingredient__amount input`).value = ingredient.practicalQuantity.amount.formatted;
			this.el.querySelector(`.profile-diary-day-meal-ingredient[data-id="${id}"] .profile-diary-day-meal-ingredient__unit select`).value = ingredient.practicalQuantity.unit.id;
			this.el.querySelector(`.profile-diary-day-meal-ingredient[data-id="${id}"] .profile-diary-day-meal-ingredient__quantity-formatted`).innerHTML = ingredient.baseQuantity.formatted;
			for (let nutrientCode in ingredient.nutrients) {
				this.el.querySelector(`.profile-diary-day-meal-ingredient[data-id="${id}"] .profile-diary-day-meal-ingredient__nutrient[data-nutrient-code="${nutrientCode}"] .profile-diary-day-meal-ingredient__nutrient-amount`).innerHTML = ingredient.nutrients[nutrientCode].amount.formatted;
			}
		}

		for (let id in values?.userIngredients || []) {
			let userIngredient = values.userIngredients[id];
			this.el.querySelector(`.profile-diary-day-meal-user-ingredient[data-id="${id}"] .profile-diary-day-meal-user-ingredient__amount input`).value = userIngredient.baseQuantity.amount.formatted;
			// this.el.querySelector(`.profile-diary-day-meal-user-ingredient[data-id="${id}"] .profile-diary-day-meal-user-ingredient__unit select`).value = userIngredient.baseQuantity.unit.id;
			this.el.querySelector(`.profile-diary-day-meal-user-ingredient[data-id="${id}"] .profile-diary-day-meal-user-ingredient__quantity-formatted`).innerHTML = userIngredient.baseQuantity.formatted;
			for (let nutrientCode in userIngredient.nutrients) {
				this.el.querySelector(`.profile-diary-day-meal-user-ingredient[data-id="${id}"] .profile-diary-day-meal-user-ingredient__nutrient[data-nutrient-code="${nutrientCode}"] .profile-diary-day-meal-user-ingredient__nutrient-amount`).innerHTML = userIngredient.nutrients[nutrientCode].amount.formatted;
			}
		}

		for (let id in values?.deliProducts || []) {
			let deliProduct = values.deliProducts[id];
			this.el.querySelector(`.profile-diary-day-meal-deli-product[data-id="${id}"] .profile-diary-day-meal-deli-product__amount input`).value = deliProduct.baseQuantity.amount.formatted;
			// this.el.querySelector(`.profile-diary-day-meal-deli-product[data-id="${id}"] .profile-diary-day-meal-deli-product__unit select`).value = deliProduct.baseQuantity.unit.id;
			this.el.querySelector(`.profile-diary-day-meal-deli-product[data-id="${id}"] .profile-diary-day-meal-deli-product__quantity-formatted`).innerHTML = deliProduct.baseQuantity.formatted;
			for (let nutrientCode in deliProduct.nutrients) {
				this.el.querySelector(`.profile-diary-day-meal-deli-product[data-id="${id}"] .profile-diary-day-meal-deli-product__nutrient[data-nutrient-code="${nutrientCode}"] .profile-diary-day-meal-deli-product__nutrient-amount`).innerHTML = deliProduct.nutrients[nutrientCode].amount.formatted;
			}
		}

		for (let code in values?.nutrients || []) {
			let nutrient = values.nutrients[code];
			try {
				this.el.querySelector(`.profile-diary-day-meal-nutrient[data-code="${code}"] .profile-diary-day-meal-nutrient__amount`).innerHTML = nutrient.formatted;
			} catch (error) {
				// Nevermind.
			}
		}

		BApp.refresh();
	}
}
